// Targets of the help articles written in USG EOL comms task 4/5. A notice must not be
// launched (portal_notice_launches row) before its article is published.
export const HELP_LINKS = {
  usg: 'https://help.cloudunifi.com/unifi/usg-end-of-life/',
  holdVersion: 'https://help.cloudunifi.com/unifi-os-server/updates/#holding-a-network-version',
  standalone: 'https://help.cloudunifi.com/standalone-unifi/network-10-6-last-release/',
  migrating: 'https://help.cloudunifi.com/unifi-os-server/migrating-with-us/',
  stripe: 'https://help.cloudunifi.com/billing/switch-to-stripe/',
  notices: 'https://help.cloudunifi.com/portal/notices/',
  uispPhp2shell: 'https://help.cloudunifi.com/uisp/php2shell-security-update/',
} as const;
